import { i18n } from "@/fit-components/common/lang";

export interface DialogBtn {
    click?: () => void;
    text: string;
}
export interface DialogOptions {
    title?: string;
    content?: string;
    htmlContent?: string;
    btns?: DialogBtn[];
    show?: boolean;
    align?:string;
}

export function getDefaultConfig(): DialogOptions {
    return Object.assign({}, {
        show: false,
        title: '',
        content: '',
        htmlContent: '',
        btns: [{
            text: i18n('确定'),
        }],
        align:''
    });
}
